function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useCallback, useRef, useState } from 'react';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
var noop = () => Promise.resolve();
export var ERROR_MESSAGE = 'Something went wrong, please try again later';
var useModalControl = args => {
  var _ref = args || {},
    _ref$onReset = _ref.onReset,
    onReset = _ref$onReset === void 0 ? () => {} : _ref$onReset,
    _ref$onCompleted = _ref.onCompleted,
    onCompleted = _ref$onCompleted === void 0 ? () => {} : _ref$onCompleted;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var submitFunction = useRef(noop);
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useAllhomesApi = useAllhomesApi(),
    getLogger = _useAllhomesApi.getLogger;
  var log = getLogger('fe-co-allhomes-followed-properties-dialogs#useModalControl');
  var openModal = useCallback(function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      submitHandler = _ref2.onSubmit,
      initialError = _ref2.error;
    log.info('Opening modal');
    if (initialError) {
      log.warn('Initial error set:', initialError);
      setError(initialError);
    } else if (submitHandler) {
      log.info('Updating submit handler');
      submitFunction.current = submitHandler;
    } else {
      log.info('no submit handler, setting a generic error');
      setError(ERROR_MESSAGE);
    }
    setShow(true);
  }, [log]);
  var resetState = useCallback(() => {
    log.info('resetting modal state');
    submitFunction.current = noop;
    setShow(false);
    setError(null);
    onReset();
  }, [log, onReset]);
  var closeModal = resetState;
  var handleSubmit = useCallback(data => {
    log.info('in handle submit, running submitFunction');
    Promise.resolve(submitFunction.current(data)).then(() => {
      log.info('submit competed, running onCompleted');
      onCompleted();
      log.info('onCompleted run');
      resetState();
    }).catch(() => {
      log.warn('Caught an exception running submit');
      setError(ERROR_MESSAGE);
    });
  }, [log, onCompleted, resetState]);
  return {
    modalProps: {
      show,
      error,
      onClose: resetState,
      onSubmit: handleSubmit
    },
    setError,
    openModal,
    closeModal,
    resetState
  };
};
export default useModalControl;